import { Budget } from './budget'
import { Message } from './message'
import { Proposal } from './proposal'
import { DocumentData, FirestoreDataConverter } from 'firebase/firestore'

export const PROJECT_STATUS = {
  LEAD: 'lead',
  ESTIMATING: 'estimating',
  AWAITING_ACCEPTANCE: 'awaiting_acceptance',
  LOST: 'lost',
  IN_PROGRESS: 'work_in_progress',
  COMPLETED: 'completed',
  INVOICING: 'invoicing',
  ARCHIVED: 'archived'
}

export interface SyncMetadata {
  qboId?: string
  lastSynced?: number
  lastSyncStatus?: 'success' | 'error' | 'conflict'
  lastSyncError?: string
  conflictData?: any
  syncToken?: string
}

export class Project {
  id: string
  name: string
  status: string
  type: 'residential' | 'commercial' | 'pre_sale' | 'property_management' | 'residential_realtor' | 'residential_homeowner'
  dueDate: Date
  address: string
  description: string
  customerId: string
  migrationMetada: string

  salesPersonId: string
  projectManagerId: string
  estimatorId: string
  realtorId: string
  budget: Budget
  // changeOrder?: null // ChangeOrder[]
  proposal: Proposal
  messages: Message[]
  syncMeta?: SyncMetadata
  createdAt: Date
  updatedAt: Date

  constructor () {
    this.id = ''
    this.name = ''
    this.status = PROJECT_STATUS.ESTIMATING
    this.customerId = ''
    this.createdAt = new Date()
    this.updatedAt = new Date()
  }
}

export const projectConverter: FirestoreDataConverter<Project, DocumentData> = {
  toFirestore: (project: Project) => { 
    project.createdAt = project.createdAt ? new Date(project.createdAt) : new Date()
    project.updatedAt = new Date()

    return Object.assign({}, JSON.parse(JSON.stringify(project)))
  },

  fromFirestore: (snapshot: any, options: any) => {
    const data = snapshot.data(options)
    data.dueDate = (typeof data.dueDate === 'object') ? data.dueDate.toDate() : data.dueDate
    data.createdAt = (typeof data.createdAt === 'object') ? data.createdAt.toDate() : data.createdAt
    data.updatedAt = (typeof data.updatedAt === 'object') ? data.updatedAt.toDate() : data.updatedAt

    return Object.assign(new Project(), JSON.parse(JSON.stringify(data))) as Project
  }
}
